import { render, staticRenderFns } from "./OsReportContentCategoriesOverview.vue?vue&type=template&id=44287641&scoped=true"
import script from "./OsReportContentCategoriesOverview.vue?vue&type=script&lang=ts"
export * from "./OsReportContentCategoriesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44287641",
  null
  
)

export default component.exports